export default "__VITE_ASSET__B02DSq1W__"